import React, { useLayoutEffect, useRef, useState } from 'react';
import { components } from 'react-select';

export const ROW_HEIGHT_PX = 32;

const MaxRowsValueContainer = ({ children, selectProps, ...props }: any) => {
   const { maxRows, onShowMoreClick } = selectProps;
   const maxH = ROW_HEIGHT_PX * maxRows;
   const containerRef = useRef<HTMLDivElement>(null);
   const [hiddenCount, setHiddenCount] = useState(0);

   const childArray = React.Children.toArray(children);
   const input = childArray[childArray.length - 1];
   const values = childArray.slice(0, -1);

   useLayoutEffect(() => {
      if (!containerRef.current) return;
      const containerTop = containerRef.current.getBoundingClientRect().top;
      const all = Array.from(containerRef.current.children) as HTMLElement[];
      const chipsOnly = all.slice(0, -1); // exclude Input (always last child)
      const hidden = chipsOnly.filter(el => {
         const rect = el.getBoundingClientRect();
         return rect.top - containerTop + rect.height > maxH;
      }).length;
      setHiddenCount(hidden);
   });

   return (
      <components.ValueContainer {...props} selectProps={selectProps}>
         <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
            <div
               ref={containerRef}
               style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  gap: '4px',
                  maxHeight: `${maxH}px`,
                  overflow: 'hidden',
                  padding: '2px 0',
               }}
            >
               {values}
               {input}
            </div>
            {hiddenCount > 0 && (
               <button
                  type="button"
                  onMouseDown={e => {
                     e.preventDefault();
                     e.stopPropagation();
                     onShowMoreClick?.();
                  }}
                  className="flex items-center bg-lightGray text-primary font-semibold rounded text-[13px] py-1 px-3 h-7 shrink-0 hover:bg-cyan-50 mt-1 self-start"
               >
                  {`(+${hiddenCount}) More...`}
               </button>
            )}
         </div>
      </components.ValueContainer>
   );
};

export default MaxRowsValueContainer;
